import { Injectable } from '@angular/core'
import { Observable, defer } from 'rxjs'
import { map } from 'rxjs/operators'

import { GoRealtimeClient } from '@core/services/realtime/go-realtime.client'
import { NotificationMessage } from './notification-message.model'
import { WebAlert, normalizeWebAlert } from './web-alert'

/**
 * App-wide realtime alert stream over the v3 native WS (independent of the map page).
 *
 * On the FIRST subscription it ensures the shared GoRealtimeClient is connected (token mode, idempotent
 * with the map's connection — Q2 allows multiple; one socket demuxes position$ + alert$), then maps each
 * flat WebAlert -> NotificationMessage. It never disconnects the client (logout does, via AuthService).
 * `defer` keeps it dormant until subscribed, so it has no effect on the v2 socket.io path.
 */
@Injectable({ providedIn: 'root' })
export class RealtimeAlertService {
  readonly alerts$: Observable<NotificationMessage> = defer(() => {
    this.client.connect()
    return this.client.alert$
  }).pipe(map((raw: WebAlert) => normalizeWebAlert(raw)))

  constructor(private client: GoRealtimeClient) {}
}
